export default __webpack_public_path__ + "static/media/postman.e65afafe.svg";